























































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import {
  MessagesViewModel,
  FileViewModel,
  MessageCreateViewModel,
} from '@/models/telephony/message';
import { Route } from 'vue-router';
import { Utils } from '@/helper/utils';
import { FileHelper } from '@/helper/file.helper';
import { PaginationModel } from '@/models/pagedlistmodel';
import {
  MetadataType,
  MetadataKeyIdentifier,
  ConversationTypes,
} from '@/enums/enums';
import { Base } from '@/components/common/base';
import { GetCustomerMessageResponse } from '@/models/accounting/getCustomerMessageResponse';
import { IDialogOption } from '@/models/dialog';
import { mapGetters, mapActions, mapState } from 'vuex';
import { conversationService, messageService, userService, vendorService } from '@/shared';
import { HubConnectionBuilder } from '@microsoft/signalr/dist/esm/HubConnectionBuilder';
import { LogLevel } from '@microsoft/signalr/dist/esm/ILogger';
import { FileUploadDataViewModel, GetMessagesByConversationId } from '@/Alynk.dtos';
import { IFileUploaderOption } from '@/models/fileUploader';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    FileUpload: () =>
      import('@/components/common/app.fileupload.v2.vue'),
    Messages: () =>
      import('@/components/common/conversation.messages.vue'),
    AppDialog: (resolve) =>
      import('@/components/common/app.dialog.vue'),
  },
  watch: {
    // call again the method if the route changes
    $route: 'OnInit',
  },
})
export default class ConversationMessagesPage extends Base {
  public MappingModel: GetCustomerMessageResponse[] = [];
  public pagination = new PaginationModel('createdAt', true);
  public pagedMessages: MessagesViewModel[] = [];
  public pagedMessages2: MessagesViewModel[] = [];
  public dashboardDetails: any;
  public constants: any = {
    tenantId: '',
    enterpriseId: '',
    storeId: '',
    conversationId: '',
    customerName: '',
    customerKey: '',
    from: '',
    to: '',
    scrollHeight: 0,
    isOlderMessages: false,
  };
  public params: any = {
    tenantId: '',
    enterpriseId: '',
    storeId: '',
    conversationId: '',
    toNumber: ''
  };
  public vendorFromNumber: string = '';
  public vendorToNumber: string = '';
  public model: MessagesViewModel = {
    guid: Utils.newGuid(),
    sending: false,
    sent: false,
    createdBy: '',
    messageJson: {
      to: null,
      from: null,
      textJson: {
        body: null,
      },
      callTypeId: ConversationTypes[ConversationTypes.Text],
    },
    metadataJson: {
      recordIdentifier: MetadataType[MetadataType.RO],
      recordKeyIdentifier:
        MetadataKeyIdentifier[MetadataKeyIdentifier.RepairOrderNumber],
    },
    attachments: [],
  };

  // tslint:disable-next-line:max-line-length
  public messageToSend: MessageCreateViewModel = new MessageCreateViewModel(
    ConversationTypes[ConversationTypes.Text]
  );
  public window: any = window;
  public numbers: string[] = [];
  public fileRef: any;
  public query: any = {
    isMyText: '',
    orphan: false,
  };
  public flags: any = {
    noRecords: false,
    firstLoad: true,
    loading: false,
  };
  public loading: boolean = false;
  public pageLoading: boolean = false;
  public isMessageLoading: boolean = false;
  public sendLoading: boolean = false;
  public images = [
    '.ani',
    '.bmp',
    '.cal',
    '.fax',
    '.gif',
    '.img',
    '.jpg',
    '.jpe',
    '.jpeg',
    '.jpg',
    '.mac',
    '.pbm',
    '.pcd',
    '.pcx',
    '.pct',
    '.pgm',
    '.png',
    '.ppm',
    '.psd',
    '.ras',
    '.tga',
    '.tif',
    '.tiff',
    '.wmf',
    'image/ani',
    'image/bmp',
    'image/cal',
    'image/fax',
    'image/gif',
    'image/img',
    'image/jpeg',
    'image/mac',
    'image/pbm',
    'image/pcd',
    'image/pcx',
    'image/png',
    'image/tga',
    'image/tiff',
    'image/wmf',
    'image/ppm',
    'image/ppm',
    'image/psd',
    'image/ras',
  ];
  public audios = ['.wav', 'audio/wave'];
  public selectedFiles: any = [];
  public advisorVideoUrl: string = '';
  public showVideo: IDialogOption = {
    width: 600,
    title: this.$parent.$t('message.videoDialog.title') as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-paper-plane',
      text: this.$parent.$t('message.videoDialog.btnJoinNow') as string,
    },
    onAction: (): void => {
      this.joinVideoCall(null);
    },
  };

  public fileUploderRef: string = "conversationMessageRef";
  public files: any = [];
  public attachmentFiles: FileUploadDataViewModel[] = [];
  public uploadBtnLoading: boolean = false;
  public fileDialog: IFileUploaderOption = {
    ref: this.fileUploderRef,
    inputFiles: this.selectedFiles,
    multiple: true,
    drop: true,
    extensions: this.images.concat(this.audios),
    showIcon: true
  };

  public syncAttachmentFiles(inputFilesToSync: any[], outputFilesToSync: FileUploadDataViewModel[]) {
    this.attachmentFiles = inputFilesToSync;
    this.messageToSend.files = outputFilesToSync;
  }

  public fileUploadLoader(val: boolean) {
    this.uploadBtnLoading = val;
  }
  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'redirectToVendorRequest') {
      this.redirectToVendorRequest();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  // public updateToolBar(additionalButtons): void {
  //      // let buttons: any = [];
  //   // buttons.push({'id':'0', 'type':'button', 'title':'Send', 'disabled':false, 'visible': true, 'class':'btn', 'label':'Send', 'click':'send', 'icon':'fas fa-paper-plane'});
  //   // buttons.push({'id':'0', 'type':'button', 'title':'Initiate Video Call', 'disabled':false, 'visible': true, 'class':'btn', 'label':'Initiate Video Call', 'click':'initiateVideoCall', 'icon':'fas fa-paper-plane'});
  //   // this.$emit('updateToolBar', buttons);
  // }

  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '1',
      type: 'button',
      title: "View Request",
      disaled: false,
      visible: true,
      class: 'btn',
      label: "View Request",
      click: 'redirectToVendorRequest',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }


  public mounted() {

    if (this.$route.params.conversationId) {   // ToDo - update check to conversationId
      Object.keys(this.params).forEach((key) => {
        if (this.$route.params[key]) {
          this.params[key] = (this.$route.params[key] || '').toString().trim();
        }
      });
      this.updateToolBar();
    }

    this.$store.watch(
      (state, getters) => getters.getNotificationMsg,
      (newValue, oldValue) => {
        const result = newValue.find(
          (x) =>
            x.to === this.$route.query.to && x.from === this.$route.query.from
        );
        if (result) {
          this.bindMessage(result.body);
          newValue = newValue.filter(
            (x) =>
              x.to != this.$route.query.to && x.from != this.$route.query.from
          );
          this.$store.dispatch('setNotificationMsg', newValue || []);
        }
      }
    );
    this.OnInit();

  }
  public bindMessage(body: string) {
    if (this.pagedMessages.length > 0) {
      const firstMessage = this.pagedMessages[0];
      this.messageToSend.customerName = firstMessage.messageJson.customerName;
      this.messageToSend.vin = firstMessage.vin;
      this.messageToSend.customerKey = this.constants.customerKey;

      if (this.$route.params.conversationId) {
        var vendorCustomerName = '';
        if (this.$route.params.toNumber == firstMessage.messageJson.to.replace('+1', ''))
          vendorCustomerName = firstMessage.messageJson.customerName;
        else
          vendorCustomerName = firstMessage.firstName + ' ' + firstMessage.lastName;
        this.constants.customerName = vendorCustomerName.replace(',', '');
      } else {
        // tslint:disable-next-line:max-line-length
        this.constants.customerName = this.model.messageJson.customerName = (
          firstMessage.messageJson.customerName || ''
        ).replace(',', ' ');
      }
      this.model.messageJson.customerKey = this.constants.customerKey;
      this.model.storeName = firstMessage.storeName;
    }
    this.model.messageJson.textJson.body = body;
    this.model.messageJson.to = this.constants.to;
    this.model.messageJson.from = this.constants.from;
    this.model.guid = Utils.newGuid();
    this.model.sent = false;
    this.model.sending = false;
    this.model.createdBy = 'system';
    this.pagedMessages.push(this.model);
  }
  public async OnInit() {

    await this.getConversationPhoneNumber();
    // this.updateToolBar(null);
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.constants.customerKey = this.$route.params.customerKey || '';
    this.constants.from = this.$route.query.from;
    this.constants.to = this.$route.query.to;
    this.query.isMyText = this.$route.query.isMyText;

    this.messageToSend.recordIdentifier = MetadataType[MetadataType.RO];
    this.messageToSend.recordKeyIdentifier =
      MetadataKeyIdentifier[MetadataKeyIdentifier.RepairOrderNumber];
    this.constants.isOlderMessages = false;
    await this.getMessages();
    this.$validator.validateAll();
  }
  public joinVideoCall(val): void {
    if (val) {
      this.advisorVideoUrl = val;
    }

    this.showVideo.model = false;
    // open video in new tab
    const win = window.open(this.advisorVideoUrl, '_blank');
    win.focus();
    location.reload();
  }
  public changeOrphan(val): void {
    this.pagination.page = 1;
    this.$router.replace({
      query: {
        orphan: val,
      },
    });
  }
  public stringAvtar(name: string) {
    if (!name) {
      return name;
    }
    const splited = name.indexOf(',') > -1 ? name.split(',') : name.split(' ');
    let av = '';
    splited.forEach((s) => {
      if (s.trim()[0] && av.length < 2) {
        av += s.trim()[0];
      }
    });
    return av;
  }
  public updated() {
    if (this.pagination.page === 1) {
      this.scroll();
    }
  }
  public scroll() {
    if (
      this.$refs.messagecontainer &&
      this.$refs.messagelist &&
      !this.constants.isOlderMessage
    ) {
      this.$refs.messagecontainer['scroll']({
        top: this.$refs.messagelist['scrollHeight'],
      });
      this.$refs.messagecontainer['onscroll'] = this.scrollList;
      this.constants.scrollHeight = this.$refs.messagelist['scrollHeight'];
    }
  }
  public async getMessages(): Promise<void> {
    try {
      this.isMessageLoading = true;

      if (this.pageLoading == false) {
        this.pageLoading = true;
        this.flags.loading = true;
      }
      // tslint:disable-next-line:max-line-length
      let messages;
      if (this.params.conversationId) {
        messages = (await conversationService.getMessagesByConversationId(
          this.params.conversationId,
          this.vendorFromNumber,
          this.vendorToNumber,
          this.pagination
        )) as any;
      }

      if (!this.params.conversationId && this.constants.customerKey) {
        messages = (await conversationService.getMessagesAsync(
          this.constants.customerKey,
          this.constants.from,
          this.constants.to,
          this.pagination,
          this.constants.isOlderMessages
        )) as any;

      }

      if (messages && messages.results == undefined || messages.results.length === 0) {
        this.flags.noRecords = true;
        return;
      }

      if (this.pagination.page === 1 && !this.constants.isOlderMessages) {
        this.pagedMessages = [];
      }
      messages.results.forEach((rec) => {
        const exists = this.numbers.find((n) => n == rec.messageJson.to);
        if (
          !exists &&
          rec.messageJson.to &&
          rec.messageJson.to != rec.storePhoneNumber
        ) {
          this.numbers.push(rec.messageJson.to);
        }

        const exists1 = this.numbers.find((n) => n == rec.messageJson.from);
        if (
          !exists1 &&
          rec.messageJson.from &&
          rec.messageJson.from != rec.storePhoneNumber
        ) {
          this.numbers.push(rec.messageJson.from);
        }


        rec.guid = Utils.newGuid();
        rec.sent = false;
        rec.sending = false;
        this.pagedMessages.unshift(rec);
      });


      if (this.params.conversationId) {
        this.numbers = [];
        this.numbers.push(this.params.toNumber);
        this.messageToSend.to = this.params.toNumber;
      }




      if (this.pagedMessages.length > 0) {

        const firstMessage = this.pagedMessages[0];
        this.messageToSend.customerName = firstMessage.messageJson.customerName;
        this.messageToSend.vin = firstMessage.vin;
        this.messageToSend.customerKey = this.constants.customerKey;

        if (this.$route.params.conversationId) {

          var vendorCustomerName = '';
          if (this.$route.params.toNumber == firstMessage.messageJson.to.replace('+1', ''))
            vendorCustomerName = firstMessage.messageJson.customerName;
          else
            vendorCustomerName = firstMessage.firstName + ' ' + firstMessage.lastName;
          this.constants.customerName = vendorCustomerName.replace(',', '');
        } else {
          // tslint:disable-next-line:max-line-length
          this.constants.customerName = this.model.messageJson.customerName = (
            firstMessage.messageJson.customerName || ''
          ).replace(',', ' ');
        }
        this.model.messageJson.customerKey = this.constants.customerKey;
        this.model.storeName = firstMessage.storeName;
      }

      if (this.numbers.length === 1 && !this.constants.isOlderMessages) {
        this.model.messageJson.to = this.numbers[0];
      }
      if (this.pagination.page === 1 && !this.constants.isOlderMessages) {
        if (!this.params.conversationId) {
          this.markMessagesAsRead();
        } else {
          this.markInternalMessageAsRead();
        }
      }
    } finally {
      this.isMessageLoading = false;
      this.loading = false;
      this.flags.loading = false;
    }
  }


  public sendTypedMessage(event): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (this.params.conversationId) {
        this.sendInternalMessage();
      } else {
        this.sendMessage();
      }
    }
  }

  public async sendMessage(): Promise<void> {
    if (!this.messageToSend.to) {
      this.showAlert(false, this.$t('message.alertNumberMessageIsRequired'));
      return;
    }
    this.model.sending = true;
    try {
      this.sendLoading = true;
      this.$emit('update:progress', this.sendLoading);
      const response = await messageService.sendMessage(
        this.messageToSend
      );
      this.model.sending = false;

      if (response.data != undefined) {
        if (response.data.messageJson.videoJson != null) {
          this.advisorVideoUrl = response.data.messageJson.videoJson.urlFrom;
        }
      }

      if (this.advisorVideoUrl !== '' && this.advisorVideoUrl !== undefined) {
        this.showVideo.model = true;
      } else {
        this.showVideo.model = false;
      }
      this.showAlert(true, this.$t('message.alertMessageSentSuccessfully'));
      this.messageToSend.body = '';
      if (!this.showVideo.model) {
        location.reload();
      }
    } finally {
      this.sendLoading = false;
      this.$emit('update:progress', this.sendLoading);
      this.flags.loading = false;
      this.messageToSend.type = ConversationTypes[ConversationTypes.Text];
      this.messageToSend.files = [];
      this.selectedFiles = [];
      this.$root.$emit('resetFileList', this.fileUploderRef);
    }
  }


  public async sendInternalMessage(): Promise<void> {
    if (!this.messageToSend.to && !this.vendorFromNumber) {
      this.showAlert(false, this.$t('message.alertNumberMessageIsRequired'));
      return;
    }
    this.model.sending = true;
    try {
      this.sendLoading = true;
      const response = await vendorService.AddInternalConversation(this.params.conversationId, this.vendorFromNumber, this.messageToSend.to, this.messageToSend.body, this.messageToSend.files);
      this.model.sending = false;
      this.showAlert(true, this.$t('message.alertMessageSentSuccessfully'));
      this.messageToSend.body = '';
    } finally {
      this.sendLoading = false;
      this.flags.loading = false;
      this.messageToSend.files = [];
      this.selectedFiles = [];
      this.pagination.page = 1;
      this.pagination.rowsPerPage = 10;
      this.getMessages();
      this.messageToSend.type = ConversationTypes[ConversationTypes.Text];
      this.$root.$emit('resetFileList', this.fileUploderRef);
    }
  }

  public async createVideoCall(): Promise<void> {
    this.messageToSend.type = ConversationTypes[ConversationTypes.Video];
    this.sendMessage();
  }

  public gotoConversation(): void {
    if (this.params.conversationId) {
      if (history.state && history.length > 1) {
        history.back();
      }
      // else{
      //   this.$router.push({
      //     name: 'app.dashboard',
      //       params: {
      //         // tenantId: this.store.tenantId,
      //         // enterpriseId: this.store.enterpriseId,
      //         // storeId: this.store.storeId,
      //       },
      //   });
      // }
    } else {
      this.$router.push({
        name: 'advisor.conversations',
        params: {
          tenantId: this.constants.tenantId,
          enterpriseId: this.constants.enterpriseId,
          storeId: this.constants.storeId,
        },
        query: { isMyText: this.$route.query.isMyText },
      });
    }
  }
  public scrollList(event): void {
    if (
      event.target.scrollTop < 2000 &&
      event.target.scrollTop > 1000 &&
      !this.flags.noRecords
    ) {
      if (!this.isMessageLoading) {
        this.pagination.page += 1;
        this.getMessages();
      }
    }
  }
  public async markMessagesAsRead(): Promise<void> {
    await conversationService.markMessagesAsReadAsync(
      this.constants.customerKey,
      this.constants.from,
      this.constants.to
    );
    const notifications = await conversationService.getNotificationsAsync();
  }

  public async markInternalMessageAsRead(): Promise<void> {
    await conversationService.markInternalMessageAsReadAsync(
      this.vendorFromNumber,
      this.vendorToNumber,
      this.params.conversationId,
    );
    const notifications = await conversationService.getNotificationsAsync();
  }
  public async updateMessage(message: MessagesViewModel): Promise<void> {
    await conversationService.updateMessageStatusAsync(message.id, false);
    message.messageJson.isRead = false;
    this.showAlert(true, this.$t('message.alertMessageUpdatedSuccessfully'));
    const notifications = await conversationService.getNotificationsAsync();
  }
  public async fetchOlderMessages(): Promise<void> {
    this.constants.isOlderMessages = true;
    this.pagination.page = 1;
    this.flags.noRecords = false;
    await this.getMessages();
  }

  public sendMessageVerify(): void {

    if (this.params.conversationId) {
      this.sendInternalMessage();
    } else {
      this.sendMessage();
    }
  }

  public async getConversationPhoneNumber(): Promise<void> {
    if (this.params.conversationId) {
      this.numbers = [];
      const response = await conversationService.getConversationPhoneNumbers(this.params.conversationId, this.params.storeId);
      this.numbers.push(this.params.toNumber);
      this.vendorFromNumber = response.fromNumber;
      this.vendorToNumber = this.params.toNumber;
      this.messageToSend.to = this.params.toNumber;

      var that = this;
      const connection = new HubConnectionBuilder()
        .withUrl(Utils.API_WEB_HUB_URL)
        .configureLogging(LogLevel.Information)
        .build();
      //  connection.serverTimeoutInMilliseconds = 100000;

      const channelId = this.vendorFromNumber + '_' + this.vendorToNumber;

      connection
        .start()
        .then(function () {
          connection
            .invoke('getConnectionId', channelId)
            .then(function (connectionId) {

            })
            .catch((err) => console.error(err.toString()));
        })
        .catch(function (err) {
          console.log(err.toString());
        });

      connection.on('ConversationNotification', function (item) {
        if (item.body) {
          that.getMessages();
        }
      });


    }

  }

  public redirectToVendorRequest() {
    this.$router.push({
      name: 'vendors.approval',
      query: { conversationId: this.params.conversationId },
    });
  }
}
